import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import Container from '@/components/structure/Container';
import { useFsrboGenericContact } from '@/contexts/brandConfiguration/hooks';
import { useTranslation } from '@/hooks/useTranslations';
import { isEmail } from '@/utils/isEmail';
import { useBreakpoint } from '@/hooks/useBreakpoints';
import BlockTitle from '@/components/structure/BlockTitle';
import { getImageSrc } from '@/utils/getImageSrc';
const Item = ({ label, content, icon, }) => {
    const Icon = icon;
    return (_jsxs(Box, { display: "flex", alignItems: "center", typography: "typography.body.16.regular", children: [_jsx(Box, { as: "span", display: "flex", alignItems: "center", marginRight: "spacing.16", backgroundColor: {
                    'breakpoint.base': 'color.background.light',
                    'breakpoint.lg': 'color.surface.constant.white.default',
                }, color: "color.content.constant.black", borderRadius: "radius.16", padding: "spacing.16", children: _jsx(Icon, { size: "sizing.24" }) }), _jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.8", children: [_jsx(Box, { as: "span", color: {
                            'breakpoint.base': 'color.content.constant.black',
                            'breakpoint.lg': 'color.content.constant.white',
                        }, typography: "typography.body.16.bold", children: label }), isEmail(content) ? (_jsx(Box, { as: "a", href: `mailto:${content}`, color: {
                            'breakpoint.base': 'color.content.constant.black',
                            'breakpoint.lg': 'color.content.constant.white',
                        }, children: content })) : (_jsx(Box, { as: "span", color: {
                            'breakpoint.base': 'color.content.constant.black',
                            'breakpoint.lg': 'color.content.constant.white',
                        }, children: content }))] })] }));
};
const TextContact = ({ elements, t, isDesktop, }) => (_jsxs(Box, { flex: {
        'breakpoint.base': '1 1 100%',
        'breakpoint.lg': '0 0 50%',
    }, color: {
        'breakpoint.base': 'color.content.constant.black',
        'breakpoint.lg': 'color.content.constant.white',
    }, display: "flex", alignItems: "flex-start", justifyContent: "center", flexDirection: "column", paddingRight: {
        'breakpoint.base': 'spacing.none',
        'breakpoint.lg': 'spacing.128',
    }, children: [_jsx(Box, { marginBottom: "spacing.4", children: _jsx(BlockTitle, { children: t('fsrbo.generic.contact.title') }) }), _jsx(Box, { typography: "typography.body.16.regular", children: t('fsrbo.generic.contact.subtitlepart1') }), _jsx(Box, { typography: "typography.body.16.regular", children: t('fsrbo.generic.contact.subtitlepart2') }), _jsx(Box, { display: "flex", flexDirection: "column", gap: "spacing.32", marginTop: "spacing.24", children: elements.map((element) => (_jsx(Item, { ...element }, element.label))) }), _jsx(Box, { as: "img", marginTop: "spacing.48", src: isDesktop
                ? getImageSrc('logo-white.webp')
                : getImageSrc('logo-black.webp'), alt: "nutzungsdauer", width: {
                'breakpoint.base': '300px',
                'breakpoint.lg': 'auto',
            }, height: "auto" })] }));
export const Contact = ({ name }) => {
    const { t } = useTranslation();
    const { img, items } = useFsrboGenericContact();
    const { isDesktop, isMobile } = useBreakpoint();
    const image = isDesktop ? img.desktop : isMobile ? img.mobile : img.tablet;
    const elements = items.map((item, index) => {
        return {
            label: t(`fsrbo.generic.contact.list.item${index + 1}.label`),
            content: item.content,
            icon: item.icon,
        };
    });
    return (_jsxs(Container, { ...(name !== 'generic'
            ? {
                marginTop: {
                    'breakpoint.base': 'spacing.32',
                    'breakpoint.lg': 'spacing.80',
                },
            }
            : {}), marginBottom: {
            'breakpoint.base': 'spacing.32',
            'breakpoint.lg': 'spacing.80',
        }, children: [_jsx(Box, { as: "div", maxWidth: "100%", height: {
                    'breakpoint.base': '328px',
                    'breakpoint.md': '466px',
                }, backgroundImage: `url(${image})`, backgroundPosition: {
                    'breakpoint.base': 'center',
                    'breakpoint.md': 'left',
                    'breakpoint.lg': 'center',
                }, backgroundSize: {
                    'breakpoint.base': 'cover',
                    'breakpoint.lg': 'contain',
                }, display: "flex", flexDirection: "row-reverse", borderRadius: {
                    'breakpoint.base': 'radius.8',
                    'breakpoint.lg': 'radius.16',
                }, children: isDesktop && (_jsx(TextContact, { elements: elements, isDesktop: isDesktop, t: t })) }), !isDesktop && (_jsx(Box, { backgroundColor: "color.surface.constant.white.default", borderRadius: {
                    'breakpoint.base': 'radius.none',
                    'breakpoint.md': 'radius.16',
                }, marginTop: "-spacing.32", paddingVertical: "spacing.16", paddingHorizontal: {
                    'breakpoint.base': 'spacing.none',
                    'breakpoint.md': 'spacing.16',
                }, children: _jsx(TextContact, { elements: elements, isDesktop: isDesktop, t: t }) }))] }));
};
